import axios, { AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchLoginFailure,
  fetchLoginSuccess,
  fetchPinLoginFailure,
  fetchPinLoginSuccess,
  fetchShortPinFailure,
  fetchShortPinSuccess,
} from "./actions";
import {
  FETCH_AUTH_PIN_REQUEST,
  FETCH_AUTH_REQUEST,
  FETCH_SHORT_PIN_REQUEST,
  LOGOUT_AUTH,
} from "./action-types";
import { ILogin } from "./types";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

/*
  Worker Saga: Fired on FETCH_AUTH_REQUEST action
*/
function* fetchLoginSaga(action: any) {
  try {
    const { payload } = action;
    const response: AxiosResponse<ILogin> = yield call(
      axios.post,
      `${API_URL}/auth/login`,
      payload
    );
    localStorage.setItem("user", JSON.stringify(response.data));
    yield put(
      fetchLoginSuccess({
        user: response.data,
      })
    );
  } catch (error: any) {
    yield put(
      fetchLoginFailure({
        error: Array.isArray(error.response.data)
          ? error.response.data.map((item: { message: any }) => item.message)
          : [error.response.data.message],
      })
    );
  }
}

function* fetchShortPinToken(action: any): Generator<any, void, any> {
  try {
    const access_token = action.payload.access_token;
    const hours = action.payload.hours;

    const requestBody = {
      role: "ebook-viewer",
      period: hours,
    };

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const response = yield call(
      axios.post,
      `${API_URL}/auth/short-pin-token`,
      requestBody,
      {
        headers,
      }
    );
    yield put(fetchShortPinSuccess(response.data));
  } catch (error: any) {
    yield put(
      fetchShortPinFailure({
        error: error.message,
      })
    );
  }
}

function* fetchPinLoginSaga(action: any) {
  try {
    const pinCode: string = action.payload.pincode;
    const short_pin_token: string = action.payload.short_pin_token;

    const headers = {
      Authorization: `Bearer ${short_pin_token}`,
    };

    const response: AxiosResponse<ILogin> = yield call(
      axios.post,
      `${API_URL}/auth/pin-login`,
      { pinCode },
      {
        headers,
      }
    );
    localStorage.setItem("user", JSON.stringify(response.data));
    yield put(
      fetchPinLoginSuccess({
        user: response.data,
      })
    );
  } catch (pinError: any) {
    yield put(
      fetchPinLoginFailure({
        pinError: pinError.message,
      })
    );
  }
}

function logoutAuthSaga(action: any) {
  localStorage.removeItem("user");
}

/*
  Starts worker saga on latest dispatched `FETCH_LOGIN_REQUEST` action.
  Allows concurrent increments.
*/
function* loginSaga() {
  yield all([
    takeLatest(FETCH_AUTH_REQUEST, fetchLoginSaga),
    takeLatest(FETCH_AUTH_PIN_REQUEST, fetchPinLoginSaga),
    takeLatest(FETCH_SHORT_PIN_REQUEST, fetchShortPinToken),
    takeLatest(LOGOUT_AUTH, logoutAuthSaga),
  ]);
}

export default loginSaga;
